import { BoxProps, Text } from '@mantine/core';
import { GreyBox } from './GreyBox';
import { Circle } from './Circle';
import { DocumentsIcon } from '../../../icons';

export type DocumentBoxProps = BoxProps & {
  /** Document name */
  name: string;
};

export const DocumentBox: React.FC<DocumentBoxProps> = ({
  name,
  ...boxProps
}) => (
  <GreyBox {...boxProps}>
    <Circle>
      <DocumentsIcon />
    </Circle>
    <Text
      fw={600}
      fz="xl"
      sx={{
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      }}
    >
      {name}
    </Text>
  </GreyBox>
);
